// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import AuthPagesOverview from './AuthPagesOverview';
import LoginRoutes from './login';
import RegisterRoutes from './register';
import ForgotPasswordRoutes from './forgot-password';
import ResetPasswordRoutes from './reset-password';
import OtpRoutes from './otp';
import OtherRoutes from './other';

export default function AuthPagesRoutes() {
  return (
    <Routes>
      <Route index element={<AuthPagesOverview />} />
      <Route path="login/*" element={<LoginRoutes />} />
      <Route path="register/*" element={<RegisterRoutes />} />
      <Route path="forgot-password/*" element={<ForgotPasswordRoutes />} />
      <Route path="reset-password/*" element={<ResetPasswordRoutes />} />
      <Route path="otp/*" element={<OtpRoutes />} />
      <Route path="other/*" element={<OtherRoutes />} />
    </Routes>
  );
}
